import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=10496e64&scoped=true"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"
import style0 from "./FormLogin.vue?vue&type=style&index=0&id=10496e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10496e64",
  null
  
)

export default component.exports